<template>
    <div>
        <Header></Header>
        <div class="main-table">
            <h3>就医记录</h3>
            <el-date-picker
                    v-model="search.dateStart"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始日期"
                    :picker-options="pickerOptionsStart"
                    @change="changeEnd"
                    style="width:150px;margin-right:10px;">
            </el-date-picker>
            <el-date-picker
                    v-model="search.dateEnd"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束日期"
                    :picker-options="pickerOptionsEnd"
                    @change="changeStart"
                    style="width:150px;margin-right:10px;">
            </el-date-picker>
            <el-button type="primary" plain icon="el-icon-search" @click="searchFind()">查询</el-button>

            <el-tabs v-model="jyjl" type="card" style="margin-top:20px">
                <el-tab-pane label="门诊记录" name="first">
                    <el-table
                            :data="mzjl.list"
                            stripe
                            size="medium"
                            style="width: 100%">
                        <el-table-column prop="jzrq" label="时间" width="100"></el-table-column>
                        <el-table-column prop="jzlsh" label="就诊号" width="150"></el-table-column>
                        <el-table-column prop="ksmc" label="科室" width="110"></el-table-column>
                        <el-table-column prop="ysmc" label="医生" ></el-table-column>
                        <el-table-column prop="mzzd" label="诊断" width="180"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="270">
                            <template slot-scope="scope">
                                <router-link :to="'/jyjl/fymx/mz/'+scope.row.jzlsh"><el-button type="text">费用明细</el-button></router-link>
                                <router-link :to="'/jyjl/jyjl/mz/'+scope.row.jzlsh"><el-button type="text">检验记录</el-button></router-link>
                                <router-link :to="'/jyjl/jcjl/'+scope.row.jzlsh"><el-button type="text">检查记录</el-button></router-link>
                                <router-link :to="'/jyjl/cf/'+scope.row.jzlsh"><el-button type="text">处方</el-button></router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="prev, pager, next ,total"
                            :page-size="mzjl.pageSize"
                            :total="mzjl.totalSize"
                            :current-page.sync="mzjl.currentPage"
                            @current-change="changePageMzjl">
                    </el-pagination>
                </el-tab-pane>
                <el-tab-pane label="住院记录" name="second">
                    <el-table
                            :data="zyjl.list"
                            stripe
                            size="medium"
                            style="width: 100%">
                        <el-table-column prop="ryrq" label="入院时间" width="100"></el-table-column>
                        <el-table-column prop="cyrq" label="出院时间" width="100"></el-table-column>
                        <el-table-column prop="jzlsh" label="住院号" width="100"></el-table-column>
                        <el-table-column prop="ksmc" label="科室" width="130"></el-table-column>
                        <el-table-column prop="ysmc" label="医生" width="80"></el-table-column>
                        <el-table-column prop="ssmc" label="手术" width="180"></el-table-column>
                        <el-table-column prop="ryzd" label="入院诊断" ></el-table-column>
                        <el-table-column prop="cyzd" label="出院诊断" ></el-table-column>
                        <el-table-column prop="fyje" label="费用" width="100"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="300">
                            <template slot-scope="scope">
                                <router-link :to="'/jyjl/fymx/zy/'+scope.row.jzlsh"><el-button type="text">费用明细</el-button></router-link>
                                <router-link :to="'/jyjl/jyjl/zy/'+scope.row.jzlsh"><el-button type="text">检验记录</el-button></router-link>
                                <router-link :to="'/jyjl/jcjl/'+scope.row.jzlsh"><el-button type="text">检查记录</el-button></router-link>
                                <router-link :to="'/jyjl/ypyz/'+scope.row.jzlsh"><el-button type="text">药品医嘱</el-button></router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="prev, pager, next ,total"
                            :page-size="zyjl.pageSize"
                            :total="zyjl.totalSize"
                            :current-page.sync="zyjl.currentPage"
                            @current-change="changePageZyjl">
                    </el-pagination>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Header from './components/Header.vue'
    import {findMzjl,findZyjl} from '@/api/biApi.js'
    let moment = require("moment");

    export default{
        data(){
            return {
                search:{
                    dateStart:'',
                    dateEnd:'',
                    mdmid:''
                },
                pickerOptionsStart: {
                    disabledDate(time) {
                        return time.getTime() > Date.now()
                    }
                },
                pickerOptionsEnd:{
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                jyjl:'first',
                mzjl:{
                    list:[],
                    currentPage:1,
                    pageSize:10,
                    totalSize:0,
                },
                zyjl:{
                    list:[],
                    currentPage:1,
                    pageSize:10,
                    totalSize:0,
                }

            }
        },
        components: {
            Header
        },
        mounted(){
            let info = this.$cookies.get('LOGIN_INFO')
            this.search.mdmid = info && info.mdmId ? info.mdmId : ''
            //this.search.mdmid = 13183836

            let end = new Date();
            let start = new Date();
            start.setTime(end.getTime() - 3600 * 1000 * 24 * 365)
            this.search.dateStart = moment(start).format('YYYY-MM-DD')
            this.search.dateEnd   = moment(end).format('YYYY-MM-DD')

            if(this.search.mdmid){
                this.searchMzjlList()
                this.searchZyjlList()
            }
        },
        methods:{
            changeStart(){
                this.pickerOptionsStart = Object.assign({},this.pickerOptionsStart,{
                    disabledDate: (time) => {
                        return time.getTime() > moment(this.search.dateEnd, 'YYYY-MM-DD').valueOf()
                    }
                })
            },
            changeEnd(){
                this.pickerOptionsEnd = Object.assign({},this.pickerOptionsEnd,{
                    disabledDate: (time) => {
                        return time.getTime() < moment(this.search.dateStart, 'YYYY-MM-DD').valueOf();
                    }
                })
            },
            searchMzjlList(page=1,size=this.mzjl.pageSize){
                this.currentPage = page
                this.getMzjl(page,size);
            },
            getMzjl(page,size){
                this.mzjl.list = []
                findMzjl({
                    "mmid":this.search.mdmid,
                    "startDate":this.search.dateStart,
                    "endDate":this.search.dateEnd,
                    "size":size,
                    "page":page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        this.mzjl.list = res.list
                    }
                    this.mzjl.totalSize = res && res.total ? res.total : 0;
                }).catch(err=>{
                    this.$message.error('获取门诊记录失败');
                })
            },
            changePageMzjl(page){
                this.searchMzjlList(page);
            },
            searchZyjlList(page=1,size=this.mzjl.pageSize){
                this.currentPage = page
                this.getZyjl(page,size);
            },
            getZyjl(page,size){
                this.zyjl.list = []
                findZyjl({
                    "mmid":this.search.mdmid,
                    "startDate":this.search.dateStart,
                    "endDate":this.search.dateEnd,
                    "size":size,
                    "page":page
                }).then(res=>{
                    if(res && res.list.length > 0){
                        this.zyjl.list = res.list
                    }
                    this.zyjl.totalSize = res && res.total ? res.total : 0;
                }).catch(err=>{
                    this.$message.error('获取门诊记录失败');
                })
            },
            changePageZyjl(page){
                this.searchZyjlList(page);
            },
            searchFind(){
                if(!this.search.dateStart || !this.search.dateEnd){
                    this.$message({message: '请选择查询时间段', type: 'warning'});return false;
                }
                this.searchMzjlList(1)
                this.searchZyjlList(1)
            }
        }
    }
</script>
<style lang="scss">
    .main-table{
        max-width: 1280px;
        margin:0 auto;
        padding-left:10px;
        padding-right:10px;

        .el-pagination{
            float: right;
            margin: 10px 0px 10px 0px;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/pc/jyjl.vue